export default "__VITE_ASSET__D9Nod7PU__"